import { DbStorageBaseInfos } from "./db-storage-base-infos";

export enum S3StorageClass {
  DeepArchive = "DEEP_ARCHIVE",
  Glacier = "GLACIER",
  GlacierInstantRetrieval = "GLACIER_IR",
  IntelligentTiering = "INTELLIGENT_TIERING",
  OneZoneInfrequentAccess = "ONEZONE_IA",
  Outposts = "OUTPOSTS",
  ReducedRedundancy = "REDUCED_REDUNDANCY",
  Standard = "STANDARD",
  StandardInfrequentAccess = "STANDARD_IA",
  Snow = "SNOW",
}

export interface DbStorageAmazonS3Infos extends DbStorageBaseInfos {
  $type: "VDM.AirLab.Sdk.Core.Database.Types.DbStorageAmazonS3Infos, VDM.AirLab.Sdk.Core";
  url: string | null;
  bucketName: string | null;
  accessKey: string | null;
  secretKey: string | null;
  region: string | null;
  roleArn: string | null;
  docRoot: string | null;
  s3class: S3StorageClass | null; // = S3StorageClass.Standard;
}
